import { render, staticRenderFns } from "./inflowMallRenovation.vue?vue&type=template&id=248c59df&scoped=true"
import script from "./inflowMallRenovation.vue?vue&type=script&lang=js"
export * from "./inflowMallRenovation.vue?vue&type=script&lang=js"
import style0 from "./inflowMallRenovation.vue?vue&type=style&index=0&id=248c59df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c59df",
  null
  
)

export default component.exports